import React from "react";
import {HtmlDisplay} from "../Display";
import {GridCell} from "../Grid";
import {HelpText} from "./HelpText";
import {Notification} from "./Notification";

export interface InputLayoutProps {
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    helpText?: string;
    hideLabel?: boolean;
    raiseHelpText?: boolean;
    label?: string;
    labelClass?: string;
    large_columns?: string;
    medium_columns?: string;
    name?: string;
    error?: string;
    responseFeedback?: string;
    small_columns?: string;
    [key: string]: unknown;
}

const InputLayout: React.FC<InputLayoutProps> = ({
    children,
    className,
    disabled,
    helpText,
    hideLabel = false,
    raiseHelpText,
    label,
    labelClass,
    large_columns,
    medium_columns,
    name,
    error,
    responseFeedback,
    small_columns,
}) => {
    const showForSr = hideLabel ? "show-for-sr" : "";
    return (
        <GridCell large_columns={large_columns} medium_columns={medium_columns} small_columns={small_columns} className={className}>
            {
                label &&
                /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
               ( <label
                    aria-disabled={disabled}
                    htmlFor={name}
                    className={`${showForSr} ${labelClass}`}
                >
                    <HtmlDisplay html={label} isInline/>
                </label>
                
                
            )
                
            }
            { (helpText && raiseHelpText) && <HelpText name={name!} helpText={helpText} responseFeedback={responseFeedback}/>}
            {children}
            { (helpText && !raiseHelpText) && <HelpText name={name!} helpText={helpText} responseFeedback={responseFeedback}/>}
            <Notification error={error} name={name!} label={label}/>
        </GridCell>
    );
};

export {InputLayout};
